import { Injectable } from "@angular/core";
import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { localStorageStrategy, persistState } from "@ngneat/elf-persist-state";
import { FileUpload } from "./file-upload.model";
import { debounceTime } from "rxjs";

const fileUploadsStore = createStore({ name: "file-uploads" }, withEntities<FileUpload>());

@Injectable({ providedIn: "root" })
export class FileUploadsStore {
	constructor() {
		persistState(fileUploadsStore, {
			storage: localStorageStrategy,
			source: () => fileUploadsStore.pipe(debounceTime(1000)),
		});
	}

	public store = fileUploadsStore;

	reset = () => {
		fileUploadsStore.reset();
	};
}
